// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"137":"b1e84e825058694f","780":"8e8c498ab3272c67"}[chunkId] + ".js";
};